document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll(".megamenu-trigger");
  const sections = document.querySelectorAll("div[data-menu-name]"); // Grab all menu sections
  const tabs = document.querySelectorAll(".tab-switcher-button");
  const headerMenu = document.querySelectorAll(".header__menu .menu__item  ");
  triggers.forEach((trigger, index) => {
    trigger.addEventListener("click", (e) => {
      if (index !== triggers.length - 1) {
        e.stopPropagation();
        e.preventDefault();
      }
      let currentTarget = e.target;
      let handle = currentTarget.dataset.handle;
      const targetSectionId = `div[data-menu-name="${handle}"]`;
      const targetSection = document.querySelector(targetSectionId);
      if (targetSection) {
        // Hide other sections
        sections.forEach((section) => {
          if (section.dataset?.menuName !== handle) {
            section.classList.add("hidden");
          }
        });
        targetSection.classList.toggle("hidden");
        triggers.forEach((t) => t.classList.remove("active-link"));
        if (!targetSection.classList.contains("hidden")) {
          trigger.classList.add("active-link");
          headerMenu.forEach((menu) => {
            menu.style.pointerEvents = "none";
            menu.removeAttribute("aria-disabled");
          });
        } else {
          trigger.classList.remove("active-link");
          headerMenu.forEach((menu) => {
            menu.style.pointerEvents = "auto";
            menu.removeAttribute("aria-disabled");
          });
        }
      }
    });
  });

  // Close megamenu when clicking outside
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".megamenu-wrapper")) {
      sections.forEach((section) => {
        section.classList.add("hidden");
      });
      triggers.forEach((t) => t.classList.remove("active-link")); // Remove active class when menu is hidden
      headerMenu.forEach((menu) => {
        menu.style.pointerEvents = "auto";
        menu.removeAttribute("aria-disabled");
      });
    }
  });

  tabs.forEach((tab) => {
    tab.setAttribute("role", "tab");
    tab.setAttribute("tabindex", "0");
    tab.setAttribute("aria-selected", "false");

    let megamenu = tab.closest(".megamenu-wrapper");
    let closestTabs = megamenu.querySelectorAll(".tab-switcher-button");
    let contents = megamenu.querySelectorAll(".tab-collection-content");
    contents.forEach((content) => {
      content.setAttribute("role", "tabpanel");
      content.setAttribute("aria-hidden", "true");
    });
    // Make first tab active
    if (tabs?.length > 0 && contents?.length > 0) {
      let firstTab = megamenu.querySelector(".tab-switcher-button");
      let firstTabContent = contents?.[0];
      firstTab.classList.add("active");
      firstTab.setAttribute("aria-selected", "true");

      firstTabContent.classList.add("active");
      firstTabContent.setAttribute("aria-hidden", "false");
    }
    const switchTab = () => {
      contents.forEach((content) => content?.classList.remove("active"));
      closestTabs.forEach((btn) => btn?.classList.remove("active"));
      const targetContent = tab.dataset.tab;
      megamenu.querySelector(`.${targetContent}`)?.classList.add("active");
      tab?.classList?.add("active");
    };
    tab.addEventListener("click", switchTab);
    tab.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        switchTab();
      }
    });
  });
  let lastScrollY = window.scrollY;

  window.addEventListener("scroll", () => {
    const scrollThreshold = 120;

    // If user scrolled more than 30px from the top
    if (Math.abs(window.scrollY - lastScrollY) > scrollThreshold) {
      // Close all dropdowns/megamenu sections
      sections.forEach((section) => {
        section.classList.add("hidden");
      });

      // Remove active classes from triggers
      triggers.forEach((t) => t.classList.remove("active-link"));

      // Re-enable pointer events on header menu
      headerMenu.forEach((menu) => {
        menu.style.pointerEvents = "auto";
        menu.removeAttribute("aria-disabled");
      });

      // Update lastScrollY so we don't repeatedly trigger
      lastScrollY = window.scrollY;
    }
  });
});
